import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/tutorials-decoration.svg'
import _imports_1 from '@/assets/images/system-tutorials.svg'


const _withScopeId = n => (_pushScopeId("data-v-65190fea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-menu-list"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "material-icons" }
const _hoisted_4 = {
  key: 1,
  class: "pi-spin material-icons p-ml-2"
}
const _hoisted_5 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_6 = {
  key: 0,
  class: "support-brand"
}
const _hoisted_7 = { class: "p-flex-column" }
const _hoisted_8 = { class: "p-d-flex p-ai-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-mt-2" }, "Reach out our team for any questions or queries here:", -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "discord-text" }, "Join the GI Community on Discord now!"),
  /*#__PURE__*/_createElementVNode("div", { class: "material-icons blue-icon-big" }, "discord")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decor",
  src: _imports_0
}, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "p-mt-2",
  style: {"text-align":"center"}
}, "Tutorials", -1))
const _hoisted_18 = { class: "p-input-icon-left w-100 p-mt-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_20 = {
  style: {"width":"420px"},
  class: "p-d-flex p-jc-around decoration p-mt-4"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"white"} }, "New tutorial available now :"),
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"white"} }, "Campaign Participation")
], -1))
const _hoisted_22 = {
  style: {"overflow-y":"scroll","height":"550px"},
  class: "p-mt-4"
}
const _hoisted_23 = {
  key: 1,
  class: "page-menu-list"
}
const _hoisted_24 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_25 = {
  key: 2,
  class: "pi-spin material-icons p-ml-2"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "p-mt-2",
  style: {"text-align":"center"}
}, "Tutorials", -1))
const _hoisted_28 = { class: "p-input-icon-left w-100 p-mt-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_30 = {
  style: {"width":"420px"},
  class: "p-d-flex p-jc-around decoration p-mt-4"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"white"} }, "New tutorial available now :"),
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"white"} }, "Campaign Participation")
], -1))
const _hoisted_32 = { class: "p-mt-4 tutorials-overflow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TutorialItem = _resolveComponent("TutorialItem")!
  const _component_OverlayPanelModal = _resolveComponent("OverlayPanelModal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isSmallSidebar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item.to)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.to,
                    class: _normalizeClass([
        item.class,
        'menu-list-item',
        {
          'p-disabled': item.disabled,
          'color-white': _ctx.isNewDesignEnabled,
          'color-black': !_ctx.isNewDesignEnabled,
        },
      ]),
                    style: _normalizeStyle([item.style, `--level: ${_ctx.level};`]),
                    target: item.target,
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      (item.icon && item.label !== 'Discord Community' && item.label !== 'System Tutorials' && item.label !== 'Support')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("i", _hoisted_3, _toDisplayString(item.icon), 1),
                            _createElementVNode("span", null, _toDisplayString(item.label), 1),
                            (item.badge)
                              ? (_openBlock(), _createBlock(_component_Badge, {
                                  key: 0,
                                  class: "badge",
                                  value: item.badge,
                                  severity: item.badgeSeverity || 'success'
                                }, null, 8, ["value", "severity"]))
                              : _createCommentVNode("", true),
                            (item.actionIcon)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_4, _toDisplayString(item.actionIcon), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: _normalizeStyle([_ctx.user.type === 'brandOwner' ? 'margin-top: 150%' : 'margin-top: 250%']),
                            onMouseenter: ($event: any) => (_ctx.func(item, $event)),
                            onMouseleave: ($event: any) => (_ctx.func(item, $event)),
                            onClick: ($event: any) => (_ctx.openIcon(item, $event))
                          }, [
                            (item.label === 'Support' && _ctx.user.type === 'brandOwner')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("img", {
                                        class: "technical-support-icon",
                                        alt: "technical-support",
                                        src: _ctx.isNewDesignEnabled ?
                  require('../../assets/images/brand/technical-support-white.svg') :
                  require('../../assets/images/brand/technical-support-white.svg')
                                      }, null, 8, _hoisted_9),
                                      _createTextVNode(" Support ")
                                    ]),
                                    _hoisted_10,
                                    _createElementVNode("a", {
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args))),
                                      href: `mailto:${_ctx.supportEmail}`
                                    }, _toDisplayString(_ctx.supportEmail), 9, _hoisted_11)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            ((item.label === 'Discord Community' && _ctx.user.type === 'creator') || _ctx.user.type === 'agency')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.discord(item, $event)),
                                  class: "discord"
                                }, _hoisted_15, 8, _hoisted_12))
                              : _createCommentVNode("", true)
                          ], 44, _hoisted_5)),
                      _createVNode(_component_OverlayPanel, {
                        ref_for: true,
                        ref: "op",
                        style: {"border-radius":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_OverlayPanel, {
                        style: {"border-radius":"20px","height":"95%","width":"483px","margin-left":"280px"},
                        showCloseIcon: true,
                        ref_for: true,
                        ref: "opb",
                        appendTo: "body"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createElementVNode("span", _hoisted_18, [
                            _hoisted_19,
                            _createVNode(_component_InputText, {
                              type: "text",
                              modelValue: _ctx.searchTutorials,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTutorials) = $event)),
                              placeholder: "Search for a tutorial",
                              class: "tittle-input",
                              style: {"width":"420px"},
                              onInput: _ctx.filterTutorials
                            }, null, 8, ["modelValue", "onInput"])
                          ]),
                          _createVNode(_component_Dropdown, {
                            modelValue: _ctx.tutorials,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tutorials) = $event)),
                            options: _ctx.tutorialOptions,
                            optionLabel: "name",
                            optionValue: "value",
                            placeholder: "All Categories",
                            class: "p-dropdown p-mt-2"
                          }, null, 8, ["modelValue", "options"]),
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("div", null, [
                              _createElementVNode("div", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = true)),
                                class: "get-button"
                              }, "WATCH")
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_TutorialItem, {
                              class: "p-mt-2",
                              onShowModal: _ctx.approve,
                              item: _ctx.tutorial
                            }, null, 8, ["onShowModal", "item"])
                          ])
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_OverlayPanelModal, {
                        show: _ctx.showModal,
                        "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModal) = $event))
                      }, null, 8, ["show"])
                    ]),
                    _: 2
                  }, 1032, ["to", "class", "style", "target"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSmallSidebar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item.to)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.to,
                    class: _normalizeClass([
        item.class,
        item.label.split(' ').join('-'),
        _ctx.user.type,
        'menu-list-item menu-list-item-small',
        {
          'p-disabled': item.disabled,
          'color-white': _ctx.isNewDesignEnabled,
          'color-black': !_ctx.isNewDesignEnabled,
          'social-links': (item.label === 'System Tutorials' || item.label === 'Discord Community')
        },
      ]),
                    target: item.target,
                    role: "menuitem"
                  }, {
                    default: _withCtx(() => [
                      (item.icon)
                        ? _withDirectives((_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass(["material-icons", [
            item.label === 'My Campaigns' && _ctx.showRedBorder
              ? 'red-board'
              : '' + item.label === 'Campaigns' && _ctx.redBorderForInfluencer
                ? ''
                : ('' + item.label === 'Discord Community' && _ctx.user.type === 'creator') || _ctx.user.type === 'agency'
                  ? 'blue-icon'
                  : ('' + item.label === 'System Tutorials' && _ctx.user.type === 'creator') || _ctx.user.type === 'agency'
                    ? 'system-icon'
                    : '' + item.label === 'Support' && _ctx.user.type === 'brandOwner'
                      ? `blue-icon-brand ${_ctx.isNewDesignEnabled ? 'support-icon-white' : 'support-icon-black'}`
                      : '' + item.label === 'System Tutorials' && _ctx.user.type === 'brandOwner'
                        ? 'system-icon-brand'
                        : '',
            {
              'color-white': _ctx.isNewDesignEnabled,
              'color-black': !_ctx.isNewDesignEnabled,
            },
          ]]),
                            onMouseenter: ($event: any) => (_ctx.func(item, $event)),
                            onMouseleave: ($event: any) => (_ctx.func(item, $event)),
                            onClick: ($event: any) => {
            _ctx.openIcon(item, $event);
          _ctx.discord(item, $event);
          },
                            disabled: "true"
                          }, [
                            _createTextVNode(_toDisplayString(item.icon), 1)
                          ], 42, _hoisted_24)), [
                            [
                              _directive_tooltip,
                              item.label,
                              void 0,
                              { right: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (item.badge)
                        ? (_openBlock(), _createBlock(_component_Badge, {
                            key: 1,
                            class: "badge",
                            value: item.badge,
                            severity: item.badgeSeverity || 'success'
                          }, null, 8, ["value", "severity"]))
                        : _createCommentVNode("", true),
                      (item.actionIcon)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_25, _toDisplayString(item.actionIcon), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class", "target"]))
                : _createCommentVNode("", true),
              _createVNode(_component_OverlayPanel, {
                ref_for: true,
                ref: "op",
                style: {"border-radius":"20px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }, 512),
              _createVNode(_component_OverlayPanel, {
                style: {"border-radius":"20px","height":"95%","width":"483px","margin-left":"70px"},
                showCloseIcon: true,
                ref_for: true,
                ref: "opb",
                appendTo: "body"
              }, {
                default: _withCtx(() => [
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_InputText, {
                      type: "text",
                      modelValue: _ctx.searchTutorials,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchTutorials) = $event)),
                      placeholder: "Search for a tutorial",
                      class: "tittle-input",
                      style: {"width":"420px"},
                      onInput: _ctx.filterTutorials
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.tutorials,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tutorials) = $event)),
                    options: _ctx.tutorialOptions,
                    optionLabel: "name",
                    optionValue: "value",
                    placeholder: "All Categories",
                    class: "p-dropdown p-mt-2"
                  }, null, 8, ["modelValue", "options"]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModal = true)),
                        class: "get-button"
                      }, "WATCH")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_TutorialItem, {
                      class: "p-mt-2",
                      onShowModal: _ctx.approve,
                      item: _ctx.tutorial
                    }, null, 8, ["onShowModal", "item"])
                  ])
                ]),
                _: 1
              }, 512),
              _createVNode(_component_OverlayPanelModal, {
                show: _ctx.showModal,
                "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showModal) = $event))
              }, null, 8, ["show"])
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}